import pawn from "../assets/images/WPawn.png";
import bishop from "../assets/images/BBishop.png";
import knight from "../assets/images/WQueen.png";
import { courses } from "../data/homeData";
import { useNavigate } from "react-router-dom";
import chat from "../assets/images/chat.jpeg";
import calender from "../assets/images/calendar.jpeg";
import book from "../assets/images/book.jpeg";
import book2 from "../assets/images/book2.jpeg";

const iconMap = {
  Beginner: pawn,
  Intermediate: bishop,
  Advanced: knight,
};

const FeaturedCourses = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* HEADER – SAME AS FEATURED TOURNAMENT */}
      <section className="section section-light-bg">
        <div className="section-header">
          <h2>Featured Courses</h2>
          <button
            className="view-all-btn"
            onClick={() => navigate("/courses")}
          >
            View All
          </button>

        </div>
      </section>

      {/* COURSES (WOOD-WRAPPED SECTION) */}
      <section className="section featured-courses">
        <div className="card-grid">
          {courses.map((course, index) => (
            <div className="course-column" key={index}>
              <div className="course-card" 
              onClick={() => navigate("/courses", { replace: true })}
              style={{ cursor: "pointer" }}
              >
                <div className="course-top-strip">
                  {course.level} →
                </div>

                <img
                  src={iconMap[course.level]}
                  alt={course.level}
                  className="course-icon"
                />

                <div className="course-content">
                  <div className="flexer inline">
                    <img src={calender} alt="calendar" />
                    <p className="course-duration">
                      <span className="course-label">Duration:</span>{" "}
                      {course.duration}
                    </p>
                  </div>

                  <div className="flexer inline">
                    <img src={book} alt="book" />
                    <p className="course-desc">
                      <span className="course-label">Who is it for?</span>{" "}
                      {course.description}
                    </p>
                  </div>

                  <div className="flexer block">
                    <img src={chat} alt="chat" />
                    <div className="course-section">
                      <h4>Topics</h4>
                      <ul>
                        {course.topics.map((topic, i) => (
                          <li key={i}>{topic}</li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div className="flexer block">
                    <img src={book2} alt="material" />
                    <div className="course-section">
                      <h4>Material</h4>
                      <ul>
                        {course.material.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

             
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default FeaturedCourses;
